import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { LoaderService } from '@services/loader.service';
import { NotificationService } from '@services/notification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  ls: LoaderService = inject(LoaderService);
  _notificationService = inject(NotificationService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMsg = '';
        if (error.error instanceof ErrorEvent) {
          console.log(`Client side error: ${error.error.message}`);
          errorMsg = 'Client side error!';          
        } else if (error.error?.errorMessage) {
          console.log(`Server side error: ${error.error.errorMessage}`);
          errorMsg = 'Server side error!';          
        } else {
          console.log(`Error Code: ${error.status}, Message: ${error.message}`);
          errorMsg = 'Server side error!';          
        }
        return throwError(() => {
          if(error.error.errorMessage==='Policy ID is required')
            return;  
          this._notificationService.showMessage(errorMsg, 3000);
          return new Error(String(error.status));
        });
      })
    );
  }
}
